import React from 'react';
import { SALUTATION } from './common/constants/add-patient';
import PatientNameAutoSuggest from './PatientNameAutoSuggest';
import { DFormEntity } from '../api/fetchDoctorGenieByOID';
import { Patient } from '../store/types/patient';
import { getErrorComp } from './PatientPhoneAutoSuggest';
import { sanitizeSalutation } from '../pages/utils';

const PatientNameAutoSuggestBlock: React.FC<{
    salutation: DFormEntity | undefined;
    dfValues: {
        [k: string]: string | number;
    };
    salutationChangeHandler: (e?: React.ChangeEvent<HTMLSelectElement>) => void;
    onNameChange: (input: string) => void;
    onAutoComplete: (patient?: Patient) => void;
    suggestionsEnabled: boolean;
    disabled: boolean | undefined;
    name: string | undefined;
    isNameError: boolean;
    isNameInputDisabled: boolean;
    isModal: boolean;
    isPhCode?: boolean;
}> = ({
    salutation,
    dfValues,
    salutationChangeHandler,
    onNameChange,
    onAutoComplete,
    suggestionsEnabled,
    disabled,
    name,
    isNameError,
    isNameInputDisabled,
    isModal,
    isPhCode,
}) => {
    return (
        <div className="w-full">
            <div className="w-full">
                {!isModal && <p className="text-neutral-3 text-14 mb-4 font-700">Patient Name *</p>}

                <div className="flex w-full gap-8">
                    {salutation ? (
                        isModal ? (
                            <div className="relative bg-darwin-neutral-50 w-120 py-10 px-12">
                                <select
                                    required
                                    disabled={!!disabled}
                                    value={sanitizeSalutation(
                                        dfValues['salutation'] as typeof SALUTATION[number],
                                    )}
                                    onChange={salutationChangeHandler}
                                    className="w-full bg-darwin-neutral-50 text-neutral-black font-600 focus:outline-none bg-transparent"
                                >
                                    <option value="">-</option>
                                    {SALUTATION.map((v, i) => (
                                        <option key={v + i + 1} value={v}>
                                            {v}
                                        </option>
                                    ))}
                                </select>
                                <div className="mimic-box"></div>
                            </div>
                        ) : (
                            <div className="add-pt-dob-select">
                                <select
                                    required
                                    value={sanitizeSalutation(
                                        dfValues['salutation'] as typeof SALUTATION[number],
                                    )}
                                    onChange={salutationChangeHandler}
                                    className="w-full text-neutral-black font-600 focus:outline-none bg-transparent"
                                >
                                    <option value="">-</option>
                                    {SALUTATION.map((v, i) => (
                                        <option key={v + i + 1} value={v}>
                                            {v}
                                        </option>
                                    ))}
                                </select>
                                <div className="mimic-box"></div>
                            </div>
                        )
                    ) : null}
                    <PatientNameAutoSuggest
                        inputValue={name ?? ''}
                        onInputChange={onNameChange}
                        onSelect={onAutoComplete}
                        suggestionsEnabled={suggestionsEnabled}
                        disabled={!!disabled}
                        isModal={isModal}
                        className={!isModal ? 'w-33p' : ''}
                        isPhCode={isPhCode}
                    />
                </div>
            </div>
            {isNameError && <div className="mt-8">{getErrorComp('Patient name is required')}</div>}
        </div>
    );
};

export default PatientNameAutoSuggestBlock;
